import { Tooltip } from 'antd';
import { Alert } from '@insight-health-ai/roseate/components';
import { useLocation } from 'react-router-dom';

import OrganizationFilter from '../../OrganizationFilter';
import { useMagicFlowContext } from '../MagicFlowContext';

const OrganizationFilterBase = OrganizationFilter as any;

export const MagicFlowOrgSelector = () => {
  const { hasOrgSelected } = useMagicFlowContext();
  const location = useLocation();
  const isRecipesRoute = location.pathname.includes(
    '/superadmin/magicflow/recipes'
  );

  return (
    <>
      <div className="flex justify-end items-center gap-2">
        <label className="text-md text-gray-600 font-medium">
          Select organization:
        </label>
        <Tooltip title={isRecipesRoute ? 'Recipes are global' : ''}>
          <span>
            <OrganizationFilterBase disabled={isRecipesRoute} />
          </span>
        </Tooltip>
        {isRecipesRoute && (
          <span className="text-xs text-gray-500">Recipes are global</span>
        )}
      </div>

      {!hasOrgSelected && !isRecipesRoute && (
        <Alert
          className="mt-3"
          appearance="info"
          message="Select an organization to manage recipes, flows, runs, and events."
        />
      )}
    </>
  );
};
